export default __webpack_public_path__ + "c8eaed22d6408dca8b1a6283348493ba.svg";